var map = {
	"./Homepage/Homepage.route.tsx": 443,
	"./LaunchPad/LaunchPad.route.tsx": 444,
	"./LaunchPadDetail/LaunchPadDetail.route.tsx": 445,
	"./Liquidity/Liquidity.route.tsx": 446,
	"./Swap/Swap.route.tsx": 447,
	"./TermOfService/TermOfService.route.tsx": 448
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 800;